import { CREATE_UNIT_URL, DELETE_UNIT_URL, LIST_UNIT_URL, UNIT_LIST_DROPDOWN, UNIT_SINGLE_DETAIL } from "../api";
import axiosInstance from "../axiosInstance";

export const createUnitType = (props) => onResponse => {
    try {
        axiosInstance.post(CREATE_UNIT_URL, props)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listUnitType = (props) => onResponse => {
    try {
        let BASE_URL = LIST_UNIT_URL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props?.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props?.order) {
            BASE_URL += 'order=' + props.order + '&'
        }
        if (props?.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props?.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const getSingleUnitDetail = (props) => onResponse => {
    try {
        let BASE_URL = UNIT_SINGLE_DETAIL + '?'
        if (props?.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props?.id) {
            BASE_URL += 'id=' + props.id + '&'
        }

        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const deleteUnit = (props) => onResponse => {
    try {


        axiosInstance.delete(DELETE_UNIT_URL, { data: { id: props?.id } })
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });

    } catch (error) {

    }

};

export const listUnitDropdown = (props) => onResponse => {
    try {
        let BASE_URL = UNIT_LIST_DROPDOWN + '?'
        if (props.page) {
            BASE_URL += 'page=' + props.page + '&'
        }
        if (props.limit) {
            BASE_URL += 'limit=' + props.limit + '&'
        }
        if (props.search) {
            BASE_URL += 'search=' + props.search + '&'
        }
        if (props.museum_id) {
            BASE_URL += 'museum_id=' + props.museum_id + '&'
        }
        if (props.sort_by) {
            BASE_URL += 'sort_by=' + props.sort_by + '&'
        }
        axiosInstance.get(BASE_URL)
            .then((response) => {
                // console.log(response)
                onResponse(response.data);
            })
            .catch((err) => {
                console.log(err)
                onResponse(err.response?.data);
            });



    } catch (error) {

    }
}
